import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { selectLangObj } from '../../../reducers/langReducer';
import { ChevronLeftIcon, ChevronRightIcon, EllipsisHorizontalIcon } from '@heroicons/react/24/outline';

export default function Pagination({ title, pagenum, totalpages, count, items, onPageSet }) {


    var [pages, setPages] = useState([]);
    var [startsGood, setStartGood] = useState(false);
    var [endsGood, setEndGood] = useState(false);

    const langObj = useSelector(selectLangObj);


    useEffect(()=>{
        let startGood = pagenum - 3 > 0;
        let endGood = pagenum + 3 > totalpages;
        let start = startGood ? pagenum - 3 : 0;
        let end = endGood ? totalpages : pagenum + 3;
        var pages = [];
        setEndGood(endGood);
        setStartGood(startGood);
        for (let index = start; index < end; index++) {
    
    
            pages.push({
                name: index + 1,
                index: index,
                active: index == pagenum
            })
        }
        setPages(pages);

    }, [title, pagenum, totalpages, count, items, onPageSet ])
  
    var onPageSetInt = (e) => {
        if (e < 1 || e >= totalpages) {
            return;
        }

        onPageSet(e)
    }

    var setPage = (e) => {

        return el => onPageSet(e.index)
    }

    return (
        <div className='h-full flex flex-col '>

            <div className='flex-grow min-h-0 overflow-y-auto flex flex-col items-center gap-3'>
                {title &&
                    (<div className='self-start text-white  text-md sm:text-xl'>
                        {title}
                    </div>)
                }
                <div className='self-start text-xs sm:text-md text-white'>
                    {count ? (count + " " + langObj["RowsFound"]) : langObj["NothingFound"]}
                </div>


                {
                    count ? items : ""
                }

            </div>
            {
                count ? (

                    <div className='flex p-3 text-slate-600 gap-3 items-center'>
                        <button>
                            <ChevronLeftIcon onClick={el => onPageSetInt(pagenum - 1)} className='size-6'></ChevronLeftIcon>

                        </button>

                        {!startsGood ? "" : <EllipsisHorizontalIcon className='size-6'></EllipsisHorizontalIcon>}
                        {
                            pages.map(e => (<button key={e.name} onClick={setPage(e)} className={(e.active ? "bg-beige-600 text-slate-600" : "bg-slate-700 text-white") + '  rounded-full size-6 text-sm '}>{e.name}</button>))

                        }

                        {endsGood ? "" : <EllipsisHorizontalIcon className='size-6'></EllipsisHorizontalIcon>}
                        <button>
                            <ChevronRightIcon onClick={el => onPageSetInt(pagenum + 1)} className='size-6'></ChevronRightIcon>

                        </button>
                    </div>
                ) : ""}

        </div>
    )
}
